export const inspectTable_1 = [
  {
    id: 1,
    label: '최소 바닥면적 6㎡ 이상',
    is_checked: '',
    title: '크기',
    titleColor: '#F9F9F9',
  },
  {
    id: 2,
    label: '바닥면에서 천장까지 높이 2.1m 이상',
    is_checked: '',
    title: '크기',
  },
  {
    id: 3,
    label: '교대근무, 휴식형태, 휴식주기, 동시 사용인원 등을 고려하여 근로자대표와 협의한 경우 협의 면적을 최소 면적으로 함',
    is_checked: '',
    title: '크기',
  },
  {
    id: 4,
    label: '휴식시간에 이용하기 편리하고, 작업장소와 가까운 곳에 위치',
    is_checked: '',
    title: '위치',
    titleColor: '#F9F9F9',
  },
  {
    id: 5,
    label: '화재·폭발 등의 위험이 있은 장소, 유해물질을 취급하는 장소, 인체에 해로운 분진 증을 발산하거나 소음에 노출되어 휴식을 취하기 어려운 장소에 떨어진 안전한 곳에 위치',
    is_checked: '',
    title: '위치',
  },
  {
    id: 6,
    label: '온도 : 적정 온도 유지(18 ~ 28℃)',
    is_checked: '',
    title: '환경',
    titleColor: '#F9F9F9',
  },
  {
    id: 7,
    label: '습도 : 적정 습도 유지(50 ~ 55%)',
    is_checked: '',
    title: '환경',
  },
  {
    id: 8,
    label: '조명 : 작정 밝기 유지(100 ~ 200LUX)',
    is_checked: '',
    title: '환경',
  },
  {
    id: 9,
    label: '환기 : 창문 등을 통한 환기 실시, 환기설비 활용하여 쾌적한 공기질 확보',
    is_checked: '',
    title: '환경',
  },
  {
    id: 10,
    label: '소음 : 휴식에 방해되지 않는 정도의 소음',
    is_checked: '',
    title: '환경',
  },
  {
    id: 11,
    label: '마감재 : 화재발생에 대비하여 내화성이 있는 재료 사용\n' +
      '쉽게 더렵혀지지 않으며, 청소하기 쉬운 재료 사용',
    is_checked: '',
    title: '환경',
  },
  {
    id: 12,
    label: '의자 등 휴식에 필요한 비품 구비',
    is_checked: '',
    title: '비품',
    titleColor: '#F9F9F9',
  },
  {
    id: 13,
    label: '마실 수 있는 물이나 식수 설비 구비',
    is_checked: '',
    title: '비품',
  },
  {
    id: 14,
    label: '기자재, 청소도구, 수납공간은 별도로 확보',
    is_checked: '',
    title: '비품',
  },
  {
    id: 15,
    label: '휴게시설을 알아볼 수 있는 표지를 외부에 부착',
    is_checked: '',
    title: '표지 부착',
    titleColor: '#F9F9F9',
  },
  {
    id: 16,
    label: '관리담당자 지정',
    is_checked: '',
    title: '관리',
    titleColor: '#F9F9F9',
  },
  {
    id: 17,
    label: '휴게시설을 주기적으로 청소, 소독이나 세탁 등 실시',
    is_checked: '',
    title: '관리',
  },
  {
    id: 18,
    label: '휴게시설 목적 외의 용도로 사용 금지',
    is_checked: '',
    title: '관리',
  },
  {
    id: 19,
    label: '눈치를 보지 않고, 자유롭게 이용할 수 있는 문화 조성',
    is_checked: '',
    title: '이용문화',
    titleColor: '#F9F9F9',
  },
  {
    id: 20,
    label: '업무강도가 높거나 근무시간 중 휴식이 필요한 근로자 우선 이용',
    is_checked: '',
    title: '이용문화',
  },
  {
    id: 21,
    label: '불편사항 개선',
    is_checked: '',
    title: '이용문화',
  },
  {
    id: 22,
    label: '휴게시설 주요 체크리스트 활용',
    is_checked: '',
    title: '이용문화',
  },
];
